import React from 'react';
import { BodyObject, ComponentType } from '../../../../../../types/api';
import { LI } from '../../../../../../wag-react/core-components/li';
import { OL } from '../../../../../../wag-react/core-components/ol';
import { Box } from '../../../../../../wag-react/next-components/box';
import { Button } from '../../../../../../wag-react/next-components/button';
export type WellnessArticleOverviewProps = {
  value: Extract<BodyObject, {
    type: Extract<ComponentType<React.PropsWithChildren<unknown>>, 'overview'>;
  }>['value'];
};
export const WellnessArticleOverview = ({
  value
}: WellnessArticleOverviewProps) => <Box py={['8px', '16px']} px={['4px', '16px']} my="24px" backgroundColor="#F5F5F5" data-sentry-element="Box" data-sentry-component="WellnessArticleOverview" data-sentry-source-file="index.tsx">
    <OL display="grid" gridGap="16px" data-sentry-element="OL" data-sentry-source-file="index.tsx">
      {value.map(({
      id,
      value: title
    }) => <LI key={id} fontSize={['16px', '18px']} fontWeight={800} color="wagGreen">
          <Button href={id} fontSize="inherit" fontWeight="inherit" color="inherit">
            {title}
          </Button>
        </LI>)}
    </OL>
  </Box>;